import { render, staticRenderFns } from "./Vodafone.vue?vue&type=template&id=d64ffc92&scoped=true"
import script from "./Vodafone.vue?vue&type=script&lang=js"
export * from "./Vodafone.vue?vue&type=script&lang=js"
import style0 from "./Vodafone.vue?vue&type=style&index=0&id=d64ffc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64ffc92",
  null
  
)

export default component.exports